import { useContext } from './useContext';
import { FDealType, dealTypeFromJsonQuery } from '../../../JsonQuery';

export function useDealType(): FDealType {
  const { jsonQuery } = useContext();

  return dealTypeFromJsonQuery(jsonQuery);
}
